export const createImage = (source) => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', () => resolve(image));
        image.addEventListener('error', error => reject(error));
        image.src = (source instanceof Blob) ? URL.createObjectURL(source) : source;
    });
};
